'use strict';
import Common from '../../Utils/Common';

/**
 * @classname DefaultErrorModal
 * @classdesc デフォルトエラーモーダル
 */
export default class DefaultErrorModal {
	/**
	 * @constructor
	 * @param {jQuery} $e - #show-error-modal
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`);
		if($e.val() !== ''){
			Common.showErrorModal($e.val());
		}
	};
};
